<template>
  <el-container style="height: 100%;">
    <el-aside :class="{'sidebar-hidden': sidebarHidden}" class="sidebar din-regular" v-show="groups !== null" width="310px">
      <scrollactive ref="scrollactive"
                    :offset="100"
                    :duration="600"
                    :always-track="false"
                    :scroll-container-selector="cScrollContainerSelector"
                    :modify-url="false"
                    class="sidebar-scrollactive"
                    active-class="active"
                    @before-item-changed="beforeItemChanged"
                    @itemchanged="onItemChanged">
        <ul style="list-style-type:none; padding-left: 0px;" v-if="groups !== null">
          <li v-for="item in cGroupedItems.groups" :key="item.id">
            <group-date-from-to v-if="groupType === 'date-from-to'" :item="item" />
            <group-date-org v-else-if="groupType === 'date-org'" :item="item" />
            <group-flight v-else-if="groupType === 'flight'" :item="item" />

            <a v-else :href="`#section-${item.sectionIndex}`"
               :data-id="item.id"
               :data-item-index="item.index"
               :data-section-index="item.sectionIndex"
               class="scrollactive-item sidebar-link">{{ item.value }}</a>
          </li>
        </ul>
      </scrollactive>
    </el-aside>

    <el-container>
      <el-header height="min" style="position: relative; padding: 10px; min-height: 40px">
        <div class="header-left">
          <span v-show="groups !== null" @click="toggleSidebar()" class="hide-sidebar-icon" :title="$t(`common.${sidebarHidden?'show':'hide'}`)">
          <svg-icon v-if="!sidebarHidden" icon-class="hide-sidebar-horiz" style="width: inherit; height: inherit;" />
          <svg-icon v-if="sidebarHidden" icon-class="show-sidebar-horiz" style="width: inherit; height: inherit;" />
        </span>
          <!--<strong>Total:</strong> {{ flightOrders.length }}-->
          <!--<el-divider direction="vertical" />-->

          <div v-if="selectable" style="float: left; width: 26px; height: 26px; color: #5e7b9b;">
            <span v-show="cSelectedCount > 0" @click="deselectAll">
              <svg-icon icon-class="checkbox-indeterminate-fill" style="width: 100%; height: 100%;" />
            </span>
          </div>

          <span style="float: left; padding: 0 1rem; display: flex; align-items: center">
          <slot name="actions" :selected-count="cSelectedCount" />
        </span>
          <div v-show="cSelectedCount > 0" style="float: left; padding: 0 1rem">
            <slot name="massActions" />
          </div>
        </div>
        <div class="header-right">
          <el-select v-model="selectedSettings" :popper-append-to-body="false" :title="$t('flight-orders.columns.tableNameTitle')" multiple size="mini" placeholder="" class="column-setting" popper-class="popper-settings" @visible-change="openSetting">
            <el-option-group
              v-for="group in tableSettings"
              :key="group.label"
              :label="group.label">
              <el-option
                v-for="item in group.options"
                :key="item.key"
                :label="item.label"
                :value="item.value"/>
            </el-option-group>
          </el-select>
          <span v-if="cShowVisibleItemsIndexes" style="float: right; padding: 3px 0">
            <span>
              <span class="ts">{{ cCurrentFromIndexLabel }}</span>–<span class="ts">{{ cCurrentToIndexLabel }}</span>
            </span>
            {{ $t('common.of') }}
            <span class="ts">{{ cTotalValueLabel }}</span>
          </span>
          <div style="float: right; padding: 0 1rem">
            <slot name="toolbarRight" />
          </div>
        </div>
      </el-header>
      <el-main style="padding: 0px; height: 100%;" class="din-regular vue-recycle-scroller content">
        <div class="wrapper">
          <div class="header-center" style="display: flex; justify-content: center">
            <div v-if="!cWidthCalculatedData || cWidthCalculatedData.length == 0" class="no-orders-message">{{ $t('flight-orders.no-orders-found') }}</div>
          </div>
          <RecycleScroller
            v-if="isRecycleScroller"
            ref="scroller"
            :key="pageModeFullPage"
            :items="cGroupedItems.items"
            :min-height="40"
            :buffer="buffer"
            :page-mode="pageMode"
            :emit-update="true"
            class="scroller"
            key-field="id"
            size-field="height"
            @visible="onVisible"
            @hidden="onHidden"
            @update="debounceOnUpdate"
          >
            <template v-slot="{ item, index, active }">
              <template v-if="item">
                <section
                  v-if="groups !== null && item.type === 'group'"
                  :id="`section-${item.sectionIndex}`"
                  :data-index="index"
                  :data-item-index="item.index"
                  :data-section-index="item.sectionIndex"
                  class="tr din-medium letter big"
                >
                  <group-row :group-type="groupType" :item="item" />
                  <slot :group-item="item.value" name="groupActions" />
                </section>

                <div v-if="item.type === 'personHeader' || item.type === 'cargoHeader'">
                  <flight-order-header
                    class="test"
                    :item="item"
                    :index="index"
                    :selectable="selectable"
                    :options="cItemOptions"
                    :table-key-prefix="tableKeyPrefix"
                    :col-width="{ columnWidthPerson, columnWidthCargo }"
                  />
                </div>

                <span v-if="item.type === 'person' || item.type === 'cargo'" class="priority-icon-container">
                  <svg-icon v-if="item.value._flightOrder.orderData.priority > 5" class="high-priority" icon-class="arrow-up" />
                  <svg-icon v-else-if="item.value._flightOrder.orderData.priority < 5" class="low-priority" icon-class="arrow-down" />
                </span>

                <flight-order-row-check
                  v-if="selectable && (item.type === 'person' || item.type === 'cargo')"
                  v-show="!item.inactive"
                  :item="item"
                  class="row-checkbox"
                  @click:item="onClickItem"
                />

                <flight-order-row
                  v-if="item.type === 'person' || item.type === 'cargo'"
                  :item="item"
                  :index="index"
                  :class="[(selectable && 'selectable'), (item.indexWithinType === 0 ? 'first-within-type' : null), (item.value.errors && 'row-error')]"
                  :options="cItemOptions"
                  :edit-mode="editMode"
                  :table-key-prefix="tableKeyPrefix"
                  :col-width="{ columnWidthPerson, columnWidthCargo }"
                  :modified="item.value._flightOrder && (modifiedItemsKeys.indexOf(item.value._flightOrder.id) > -1)"

                  :data-index="index"
                  :data-item-index="item.index"
                  :data-section-index="item.section.sectionIndex"

                  @click:item="onClickItem"
                  @dblclick:item="onDblClickItem"
                >
                  <template v-for="slotName in cColumnSlotsName" v-slot:[slotName]>
                    <slot :name="slotName" :order="item.value" :group-item="item.value" />
                  </template>
                </flight-order-row>
                <row-actions v-if="!editMode && (item.type === 'person' || item.type === 'cargo')"
                             :item="item"
                             class="row-action-w">
                  <slot :flight-order="item.value" :group-item="item.value" name="rowActions" />
                </row-actions>

                <!--<el-divider v-if="item.isLastInGroup"><i class="el-icon-star-on" /></el-divider>-->
              </template>
            </template>
          </RecycleScroller>
        </div>
      </el-main>
      <el-footer class="footer-container" v-if="selectable" v-show="cSelectedCount > 0">
        <div v-show="cSelectedCount > 0" style="float: left; padding: 3px 0">
          <span>{{ $t('common.selected') }}: {{ cSelectedCount }}</span>
        </div>
      </el-footer>
    </el-container>
    <el-aside v-if="!!$slots.rightPanel">
       <slot name="rightPanel" />
    </el-aside>
  </el-container>
</template>

<script>
// npm
import { debounce } from 'lodash'
// vue
// rest
// other
import { getItemSize, groupFlightOrders } from './flightOrdersData'
import GroupDateFromTo from './GroupDateFromTo'
import GroupDateOrg from './GroupDateOrg'
import GroupRow from './GroupRow'
import FlightOrderHeader from './FlightOrderHeader'
import FlightOrderRowCheck from './FlightOrderRowCheck'
import FlightOrderRow from './FlightOrderRow'
import RowActions from '@/components/meridian/RowActions'
import GroupFlight from '@/components/flight-orders/scrolled/GroupFlight'
import SvgIconAction from '@/components/meridian/SvgIconAction'
import {columnsFull} from "@/utils/columnLists";
import {getTableColumnsData} from "@/utils/columns";

export default {
  name: 'FlightOrdersRecycleScroll',
  components: {GroupFlight, GroupDateFromTo, GroupDateOrg, GroupRow, FlightOrderHeader, FlightOrderRowCheck, FlightOrderRow, RowActions, SvgIconAction },

  props: {
    flightOrders: {
      type: Array, default: null
    },
    widthCalculatedData: {
      type: Array, default: null
    },
    contentSize: {
      type: String, default: 'sm'
    },
    groupType: {
      type: String, default: null
    },
    groupingKeys: {
      type: Array, default: null
    },
    groupingOrders: {
      type: Array, default: null
    },
    scrollContainerSelector: {
      type: String, default: ''
    },
    selectable: {
      type: Boolean, default: true
    },
    editMode: {
      type: Boolean, default: false
    },
    tableKeyPrefix: {
      type: String, default: 'flightOrderRow'
    },
    modifiedItemsKeys: {
      type: Array, default () {return []}
    }
  },

  data: () => ({
    vueElementId: null,
    groups: [],
    items: [],
    sidebarHidden: false,

    searchAllMatches: true,
    search: '',
    debouncedSearch: [],

    renderScroller: true,
    showScroller: true,
    scopedSlots: false,
    buffer: 100,
    poolSize: 1000,
    enableLetters: true,
    pageMode: false,
    pageModeFullPage: true,

    debounceOnUpdate: null,
    debouncedSearchSet: null,
    //
    currentFromIndex: 0,
    currentToIndex: 0,

    prevSelect: {
      index: null,
      selected: null
    },
    selectedSettings: [],
    tableSettings: [],
    settingColumnsPerson: null,
    settingColumnsCargo: null,
    isRecycleScroller: true,
    recycleScrollerWidth: 0,
    selectedPerson: [],
    selectedCargo: []
  }),

  computed: {
    cWidthCalculatedData () {
      return this.widthCalculatedData ? this.widthCalculatedData : this.flightOrders
    },
    calculatedColumns () {
      this.selectedPerson = this.$store.getters.tableColumns.columnsHolder[this.personColumnsKey] || []
      this.selectedCargo = this.$store.getters.tableColumns.columnsHolder[this.cargoColumnsKey] || []
      const columnsFull = this.$store.getters.tableColumns.columns.getFull()
      let columnsPerson = {}
      let columnsCargo = {}
      if (this.cWidthCalculatedData && this.cWidthCalculatedData.length > 0) {
        this.selectedPerson.forEach(usedColumns => {
          columnsPerson[usedColumns] = columnsFull[usedColumns]
          if (columnsFull[usedColumns].width === 'auto') {
            let maxLength = 0
            this.cWidthCalculatedData.forEach(flightOrder => {
              maxLength = this.getMaxLength(this.getLength(flightOrder, usedColumns), maxLength)
            })
            columnsPerson[usedColumns].length = (maxLength < 5 ? 5 : maxLength)
          }
        })
        this.selectedCargo.forEach(usedColumns => {
          columnsCargo[usedColumns] = columnsFull[usedColumns]
          if (columnsFull[usedColumns].width === 'auto') {
            let maxLength = 0
            this.cWidthCalculatedData.forEach(flightOrder => {
              maxLength = this.getMaxLength(this.getLength(flightOrder, usedColumns), maxLength)
            })
            columnsCargo[usedColumns].length = (maxLength < 5 ? 5 : maxLength)
          }
        })
      }
      return {columnsPerson, columnsCargo}
    },
    personColumnsKey () {
      return this.tableKeyPrefix + '-personColumns'
    },
    cargoColumnsKey () {
      return this.tableKeyPrefix + '-cargoColumns'
    },
    cShowVisibleItemsIndexes () {
      return !(this.currentFromIndex === 0 && this.currentToIndex === 0)
    },
    cCurrentFromIndexLabel () {
      return this.currentFromIndex.toLocaleString()
    },
    cCurrentToIndexLabel () {
      return this.currentToIndex.toLocaleString()
    },
    cTotalValueLabel () {
      return this.cWidthCalculatedData &&  this.cWidthCalculatedData.length.toLocaleString()
    },
    cGroupedItems () {
      this.debug && console.warn('recalculate content size!')
      this.items.forEach(item => {
        this.$set(item, 'size', this.contentSize)
      })
      return {groups: this.groups, items: this.items}
    },
    cSelectedCount () {
      return this.editMode ? 0 : this.items.filter(item => item.selected).length
    },
    selectedFlightOrders () {
      return this.items.filter(item => item.selected).map(item => item.value._flightOrder)
    },
    cItemOptions () {
      return {
        height: getItemSize(this.contentSize)
      }
    },
    cScrollContainerSelector () {
      return `${this.scrollContainerSelector} .vue-recycle-scroller`
    },
    cColumnSlotsName () {
      return Object.keys(this.$scopedSlots).filter(n => n.startsWith('column-'))
    },
    columnWidthPerson () {
      const SCROLL_WIDTH = 17
      const LEFT_PADDING = 40
      const RIGHT_MARGIN = 34
      const RIGHT_PADDING = 6
      const ONE_SYMBOL = 17
      const widthForColumns = (this.recycleScrollerWidth - SCROLL_WIDTH - LEFT_PADDING - RIGHT_MARGIN - RIGHT_PADDING - (ONE_SYMBOL * (this.calculatedColumns.columnsPerson ? Object.keys(this.calculatedColumns.columnsPerson).length : 10)))
      let widthForColumnsWithout = widthForColumns
      let columnWithAutoWidth = 0
      for (let columnKey in this.calculatedColumns.columnsPerson) {
        if (this.calculatedColumns.columnsPerson[columnKey].width !== 'auto') {
          widthForColumnsWithout = widthForColumnsWithout - this.calculatedColumns.columnsPerson[columnKey].width
        } else {
          columnWithAutoWidth += (this.calculatedColumns.columnsPerson[columnKey].length)
        }
      }
      let columnsPerson = {}
      if (widthForColumnsWithout >= columnWithAutoWidth) {
        let k = (widthForColumnsWithout / columnWithAutoWidth).toFixed(2)
        for (let columnKey in this.calculatedColumns.columnsPerson) {
          if (this.calculatedColumns.columnsPerson[columnKey].width === 'auto') {
            this.calculatedColumns.columnsPerson[columnKey].newLength = parseFloat((this.calculatedColumns.columnsPerson[columnKey].length * k).toFixed(2))
            columnsPerson[columnKey] = this.calculatedColumns.columnsPerson[columnKey].newLength
          } else {
            columnsPerson[columnKey] = this.calculatedColumns.columnsPerson[columnKey].width
          }
        }
      } else {
        let k = (widthForColumnsWithout / columnWithAutoWidth).toFixed(2)
        for (let columnKey in this.calculatedColumns.columnsPerson) {
          if (this.calculatedColumns.columnsPerson[columnKey].width === 'auto') {
            this.calculatedColumns.columnsPerson[columnKey].newLength =  parseFloat((this.calculatedColumns.columnsPerson[columnKey].length * k).toFixed(2))
            columnsPerson[columnKey] = Math.abs(this.calculatedColumns.columnsPerson[columnKey].newLength)
          } else {
            columnsPerson[columnKey] = this.calculatedColumns.columnsPerson[columnKey].width
          }
        }
      }
      return columnsPerson
    },
    columnWidthCargo () {
      const SCROLL_WIDTH = 17
      const LEFT_PADDING = 40
      const RIGHT_MARGIN = 34
      const RIGHT_PADDING = 6
      const ONE_SYMBOL = 17
      // const recycleScrollerWidth = this.$refs && this.$refs['scroller'] && this.$refs['scroller'].$vnode.elm.querySelector('.vue-recycle-scroller__item-wrapper').clientWidth
      const widthForColumns = (this.recycleScrollerWidth - SCROLL_WIDTH - LEFT_PADDING - RIGHT_MARGIN - RIGHT_PADDING - (ONE_SYMBOL * (this.calculatedColumns.columnsPerson ? Object.keys(this.calculatedColumns.columnsPerson).length : 10)))
      let widthForColumnsWithout = widthForColumns
      let columnWithAutoWidth = 0
      for (let columnKey in this.calculatedColumns.columnsCargo) {
        if (this.calculatedColumns.columnsCargo[columnKey].width !== 'auto') {
          widthForColumnsWithout = widthForColumnsWithout - this.calculatedColumns.columnsCargo[columnKey].width
        } else {
          columnWithAutoWidth += (this.calculatedColumns.columnsCargo[columnKey].length)
        }
      }
      let columnsCargo = {}
      if (widthForColumnsWithout >= columnWithAutoWidth) {
        let k = (widthForColumnsWithout / columnWithAutoWidth).toFixed(2)
        for (let columnKey in this.calculatedColumns.columnsCargo) {
          if (this.calculatedColumns.columnsCargo[columnKey].width === 'auto') {
            this.calculatedColumns.columnsCargo[columnKey].newLength = parseFloat((this.calculatedColumns.columnsCargo[columnKey].length * k).toFixed(2))
            columnsCargo[columnKey] = this.calculatedColumns.columnsCargo[columnKey].newLength
          } else {
            columnsCargo[columnKey] = this.calculatedColumns.columnsCargo[columnKey].width
          }
        }
      } else {
        let k = (widthForColumnsWithout / columnWithAutoWidth).toFixed(2)
        for (let columnKey in this.calculatedColumns.columnsCargo) {
          if (this.calculatedColumns.columnsCargo[columnKey].width === 'auto') {
            this.calculatedColumns.columnsCargo[columnKey].newLength =  parseFloat((this.calculatedColumns.columnsCargo[columnKey].length * k).toFixed(2))
            columnsCargo[columnKey] = Math.abs(this.calculatedColumns.columnsCargo[columnKey].newLength)
          } else {
            columnsCargo[columnKey] = this.calculatedColumns.columnsCargo[columnKey].width
          }
        }
      }
      return columnsCargo
    }
  },

  watch: {
    cWidthCalculatedData: {
      handler: function (newValue) {
        this.update()
      },
      immediate: true
    },
    groupingKeys (newValue) {
      this.update()
    }
  },

  created () {
    this.debounceOnUpdate = debounce(this.onUpdate, 150)
  },

  mounted () {
    this.vueElementId = Object.keys(this.$el.dataset).find(k => k.indexOf('v-') === 0)
    this.recycleScrollerWidth = this.$refs && this.$refs['scroller'] && this.$refs['scroller'].$vnode.elm.querySelector('.vue-recycle-scroller__item-wrapper') && this.$refs['scroller'].$vnode.elm.querySelector('.vue-recycle-scroller__item-wrapper').clientWidth
  },

  methods: {
    update () {
      const time = Date.now()
      this.debug && console.warn('update')
      const {groups, items} = groupFlightOrders(this.cWidthCalculatedData, this.groupingKeys, this.groupingOrders, this.contentSize)
      this.debug && groups && console.log('Created %o groups with %o items in %o ms', groups.length, items.length, (Date.now() - time))

      // this.groups = groups
      // this.items = items
      this.$set(this, 'groups', groups)
      this.$set(this, 'items', items)
      this.$set(this.prevSelect, 'ndex', null)
      return {groups: this.groups, items: this.items}
    },

    onUpdate (startIndex, endIndex) {
      this.debug && console.warn('scroller UPDATED> startIndex: %o, endIndex: %o', startIndex, endIndex)
      this.updateCount++

      const scrollactive = this.$refs.scrollactive

      // calc visible items inside window
      let nodes = scrollactive.getElementsInsideWindow('[data-section-index]', 0.5, 0.5)
        // sort nodes by data-item-index attribute
        .sort((a, b) => a.dataset.itemIndex * 1 < b.dataset.itemIndex * 1 ? -1 : 1)

      let visibleItems = nodes
        .map(n => n.dataset.itemIndex * 1)
        .map(idx => this.items[idx])
        .filter(item => {
          //console.log('item: %o', item)
          return ['cargo', 'person'].includes(item.type)
        })

      let firstItem = visibleItems.slice(0, 1).pop()
      let lastItem = visibleItems.slice(-1).pop()
      this.currentFromIndex = (firstItem && firstItem.itemIndex + 1) || 0
      this.currentToIndex = (lastItem && lastItem.itemIndex + 1) || 0

      const itemInsideWindow = scrollactive.getRealItemInsideWindow()

      scrollactive.removeActiveClass()
      if (itemInsideWindow) {
        itemInsideWindow.classList.add(scrollactive.activeClass)
      }

      this.$emit('scroll', { visibleItems })
    },

    onVisible () {
      this.debug && console.warn('visible')
    },

    onHidden () {
      this.debug && console.hidden('hidden')
    },

    beforeItemChanged(event, currentItem, lastActiveItem, hash) {
      let { id, itemIndex, sectionIndex } = event.currentTarget.dataset
      this.debug && console.log('beforeItemChanged> hash: %o, id: %o, itemIndex: %o, sectionIndex: %o', hash, id, itemIndex, sectionIndex)
      this.itemIndex = itemIndex
      this.$refs.scroller.scrollToItem(this.itemIndex)
    },
    onItemChanged(event, currentItem, lastActiveItem) {
      this.debug && console.log('onItemChanged> event: %o, currentItem: %o', event, currentItem)
    },

    onClickItem (item, event) {
      if (this.selectable) {
        const {ctrlKey, shiftKey} = event

        item.selected = !item.selected

        if (shiftKey && this.prevSelect.index && item.index !== this.prevSelect.index) {
          const selectedItems = []
          let minIdx = item.index < this.prevSelect.index ? item.index : this.prevSelect.index
          let maxIdx = item.index > this.prevSelect.index ? item.index : this.prevSelect.index
          for (let i = minIdx; i <= maxIdx; i++) {
            const item = this.items[i]
            if (['cargo', 'person'].includes(item.type) && !item.inactive) {
              item.selected = this.prevSelect.selected
              selectedItems.push(item)
            }
          }
          this.debug && console.log('%o items: %o', (this.prevSelect.selected ? 'selected' : 'deselected'), selectedItems.map(item => item.value.title))
        }

        this.prevSelect.index = item.index
        this.prevSelect.selected = item.selected

        this.$emit('select-item', item, event)
      }
      if (this.editMode) {
        this.$emit('start-edit-item', item)
      }
    },
    onDblClickItem (item) {
      if (this.selectable) {
        this.$emit('dblclick:item', item)
      }
    },

    deselectAll () {
      this.debug && console.log('deselect all')
      this.items.filter(item => item.selected).forEach(item => item.selected = false)
      this.$emit('deselect-all')
    },
    openSetting (isOpened) {
      this.debug && console.log('isOpened: %o', isOpened)
      const columnsFull = this.$store.getters.tableColumns.columns.getFull() || null
      if (isOpened) {
        this.debug && console.log('this.tableKeyPrefix: %o', this.tableKeyPrefix)
        this.selectedPerson = this.$store.getters.tableColumns.columns.get(this.tableKeyPrefix + '-personColumns') || []
        this.selectedCargo = this.$store.getters.tableColumns.columns.get(this.tableKeyPrefix + '-cargoColumns') || []
        // const { settingColumnsPerson, settingColumnsCargo } = this.$store.getters.tableColumns.columns.getFull() || null
        let settingColumnsPerson = []
        let settingColumnsCargo = []
        for (let columnKey in columnsFull) {
          if (!columnsFull[columnKey].isOnlyCargo) {
            settingColumnsPerson.push(columnKey)
          }
          if (!columnsFull[columnKey].isOnlyPerson) {
            settingColumnsCargo.push(columnKey)
          }
        }
        let settings = []
        this.selectedPerson.length > 0 && settings.push(
          {
            type: 'person',
            label: this.$i18n.t('flight-orders.header-persons'),
            options: []
          }
        )
        this.selectedCargo.length > 0 && settings.push(
          {
            type: 'cargo',
            label: this.$i18n.t('flight-orders.header-cargoes'),
            options: []
          }
        )
        settings.find(s => s.type === 'person') && settingColumnsPerson.forEach(column => {
          let list = settings.find(s => s.type === 'person').options
          list.push({
            key: 'person-' + column,
            label: this.$i18n.t('flight-orders.columns.tableName.' + column),
            value: 'person-' + column
          })
        })
        settings.find(s => s.type === 'cargo') && settingColumnsCargo.forEach(column => {
          let list = settings.find(s => s.type === 'cargo').options
          list.push({
            key: 'cargo-' + column,
            label: this.$i18n.t('flight-orders.columns.tableName.' + column),
            value: 'cargo-' + column
          })
        })
        if (settings.find(setting => setting.type === 'person')) {
          let array = settings.find(setting => setting.type === 'person').options
          array = array.sort((a, b) => columnsFull[a.key.substring(7)].number < columnsFull[b.key.substring(7)].number ? -1 : 1)
        }
        if (settings.find(setting => setting.type === 'cargo')) {
          let array = settings.find(setting => setting.type === 'cargo').options
          array = array.sort((a, b) => columnsFull[a.key.substring(6)].number < columnsFull[b.key.substring(6)].number ? -1 : 1)
        }
        this.tableSettings = settings

        this.selectedSettings = []
        this.selectedPerson.forEach(item => {
          this.selectedSettings.push('person-' + item)
        })
        this.selectedCargo.forEach(item => {
          this.selectedSettings.push('cargo-' + item)
        })
      } else {
        let personColumns = [], cargoColumns = []
        this.selectedSettings.forEach(item => {
          if (item.indexOf('person-') >= 0) {
            personColumns.push(item.slice(7))
          } else if (item.indexOf('cargo-') >= 0) {
            cargoColumns.push(item.slice(6))
          }
        })
        personColumns = personColumns.sort((a, b) => columnsFull[a].number < columnsFull[b].number ? -1 : 1)
        cargoColumns = cargoColumns.sort((a, b) => columnsFull[a].number < columnsFull[b].number ? -1 : 1)
        this.$store.dispatch('columns/setTableColumns', {
          tableKey: this.tableKeyPrefix + '-personColumns',
          columnsData: personColumns
        })
        this.$store.dispatch('columns/setTableColumns', {
          tableKey: this.tableKeyPrefix + '-cargoColumns',
          columnsData: cargoColumns
        })
        this.isRecycleScroller = false
        this.$nextTick(() => this.isRecycleScroller = true)
        setTimeout(() => {
          this.updateTable()
        }, 100)
      }
    },
    toggleSidebar () {
      this.sidebarHidden = !this.sidebarHidden
      setTimeout(() => {
        this.updateTable()
      }, 300)
    },

    /**
     * Action that called from outside
     */
    deselectFlightOrder (flightOrder) {
      let item = this.items.filter(item => ['cargo', 'person'].includes(item.type)).find(item => item.value._flightOrder.id === flightOrder.id)
      this.debug && console.log('deselect item: %o', item)
      item && (item.selected = false)
    },
    getLength (flightOrder, keys) {
      let obj = flightOrder
      keys.split('.').forEach(item => {
        if (obj) {
          obj = obj[item]
        } else {
          this.debug && console.log('item: %o', item)
        }
      })
      return obj ? obj.toString().length : 5
    },
    getMaxLength (currentLength, maxLength) {
      if (maxLength >= currentLength) {
        return maxLength
      } else {
        return currentLength
      }
    },
    updateTable () {
      this.selectedPerson = this.$store.getters.tableColumns.columns.get(this.tableKeyPrefix + '-personColumns') || []
      this.selectedCargo = this.$store.getters.tableColumns.columns.get(this.tableKeyPrefix + '-cargoColumns') || []
      this.$nextTick(() => {
        this.recycleScrollerWidth = this.$refs && this.$refs['scroller'] && this.$refs['scroller'].$vnode.elm.querySelector('.vue-recycle-scroller__item-wrapper') && this.$refs['scroller'].$vnode.elm.querySelector('.vue-recycle-scroller__item-wrapper').clientWidth
      })
    }
  }
}
</script>
<style scoped>
  .column-setting {
    float: right;
    margin-left: 5px;
  }
  >>>.column-setting .el-input__inner {
    border: none;
    width: 20px;
    padding: 0;
  }
  >>>.column-setting .el-input__prefix {
    display: flex;
    align-items: center;
  }
  >>>.column-setting .el-input__suffix {
    width: 15px;
  }
  >>>.column-setting .el-select__tags {
    display: none;
  }
  >>>.column-setting .el-input__suffix .el-icon-arrow-up {
    color: #303133;
  }
  >>>.column-setting .el-input__suffix .el-icon-arrow-up:before {
    content: "\E7AC";
  }
  >>>.column-setting .popper-settings {
    right: 0 !important;
    width: 415px !important;
    left: inherit !important;
    height: 300px;
  }
  >>>.column-setting .popper-settings .el-scrollbar__wrap {
    overflow: initial;
    margin-right: 0 !important;
  }
  >>>.column-setting .el-select-dropdown__list {
    display: flex;
    height: 300px;
  }
  >>>.column-setting .el-scrollbar {
    height: 300px;
  }
  >>>.column-setting .el-scrollbar__bar.is-vertical {
    display: none;
  }
  >>>.column-setting .popper-settings .el-select-group__wrap {
    width: 415px;
  }
  >>>.column-setting .popper-settings .popper__arrow {
    right: 0 !important;
    left: auto !important;
  }
  >>>.column-setting .el-select-group__wrap:not(:last-of-type)::after {
    display: none;
  }
  >>>.column-setting .el-select-group {
    height: 270px;
    overflow-y: scroll;
  }
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  header .header-right {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  }
</style>
<style scoped lang="scss">
  .recycle-scroller-demo:not(.page-mode) {
    height: 100%;
  }

  .recycle-scroller-demo.page-mode:not(.full-page) {
    height: 100%;
  }

  .recycle-scroller-demo.page-mode {
    flex: auto 0 0;
  }

  .recycle-scroller-demo.page-mode .toolbar {
    border-bottom: solid 1px #e0edfa;
  }

  .content {
    flex: 100% 1 1;
    border-top: solid 1px #42b983;
    position: relative;

    overflow: auto;
  }

  .wrapper {
    overflow: hidden;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .scroller {
    width: 100%;
    height: 100%;
  }

  .letter {
    text-transform: uppercase;
    color: grey;
    background-color: #c5d2e0ee;
  }

  .letter .td {
    padding: 12px;
  }

  .letter.big {
    font-size: 0.9rem;
    color: #5e7b9b;
  }

  .letter.big .value {
    /*font-size: 30px;*/
  }

  /* ******************************** */

  .tr, .td {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .vue-recycle-scroller {
    -webkit-overflow-scrolling: touch;
  }
  /deep/ .vue-recycle-scroller__item-container,
  .vue-recycle-scroller__item-wrapper {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  /deep/ .vue-recycle-scroller__item-view {
    /*cursor: pointer;*/
    -ms-user-select: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
  }
  /deep/ .vue-recycle-scroller__item-view .tr {
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

    padding-left: 20px;
    border-bottom: 1px solid #5e7b9b2e;
  }
  /deep/ .vue-recycle-scroller__item-view .td {
    display: block;
  }
  /deep/ .vue-recycle-scroller__item-view {
    &>.tr.selectable, .tr.selectable {
      /*border: 1px solid violet;*/
      padding-left: 40px; /* padding for selectable */
    }
  }
  /deep/ .vue-recycle-scroller__item-view.hover {
    /*background: #4fc08d;*/
    /*color: white;*/
    &>.tr.cargo, .tr.person {
      -webkit-box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0, 0 0px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);
      box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0, 0 0px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);
      z-index: 1;
    }
  }

  /deep/ .vue-recycle-scroller__item-view .row-actions {
    display: none;
  }
  /deep/ .vue-recycle-scroller__item-view.hover .row-actions {
    display: flex;

    /*
    background-color: #FFFFFFde;
    border-bottom: 1px solid #dcdfe6;
    */
    background-color: #5e7b9b;
    border-radius: 15px 0px 0px 15px;
    color: #fff;
  }

  .avatar {
    background: grey;
  }

  .vue-recycle-scroller__item-view .tr.first-within-type {
    /*border-top: 1px solid #e4e7ee;*/
  }
  .vue-recycle-scroller__item-view .tr.row-error {
    background-color: yellow;
  }

  /* ******************************** */

  .sidebar {
    border-right: 1px solid #e2e7ed;
    transition: 0.3s;
    transition-property: width;
  }
  a.sidebar-link.active {
    font-weight: 600;
    color: #3eaf7c;
    border-left-color: #3eaf7c;
  }

  a.sidebar-link:hover {
    color: #3eaf7c;
  }

  .sidebar a {
    display: inline-block;
  }

  a.sidebar-link {
    font-size: 1em;
    font-weight: 400;
    display: inline-block;
    color: #2c3e50;
    border-left: .25rem solid transparent;
    padding: .35rem 1rem .35rem 1.25rem;
    line-height: 1.4;
    width: 100%;
    box-sizing: border-box;
  }
  .sidebar.sidebar-hidden {
    width: 0px !important;
    overflow-x: hidden;
  }
  .sidebar-scrollactive {
    width: 300px;
  }

  .hide-sidebar-icon {
    position: absolute;
    left: -1px;
    top: 3px;
    width: 1.24em;
    height: 1.24em;
    color: #a1b1c3;
    cursor: pointer;
  }

  .row-checkbox {
    left: 9px;
    justify-content: left;
    display: flex;

    position: absolute;
    top: 0px;
    height: 100%;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

    margin: 0 12px;
  }
  .row-checkbox label.el-checkbox {
    padding: 0 2px;
  }

  .row-checkbox label.el-checkbox::before {
    content: '';
    display: block;
    opacity: 0;
    position: absolute;
    -webkit-transition-duration: .15s;
    transition-duration: .15s;
    -webkit-transition-timing-function: cubic-bezier(0.4,0.0,0.2,1);
    transition-timing-function: cubic-bezier(0.4,0.0,0.2,1);
    z-index: -1;
    bottom: -10px;
    left: -10px;
    right: -10px;
    top: -10px;
    background: none;
    border-radius: 50%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transition-property: opacity,-webkit-transform;
    transition-property: opacity,-webkit-transform;
    transition-property: transform,opacity;
    transition-property: transform,opacity,-webkit-transform;
    bottom: -10px;
    left: -10px;
    right: -10px;
    top: -10px;
  }
  .row-checkbox label.el-checkbox:hover, .row-checkbox label.el-checkbox:focus, .row-checkbox label.el-checkbox:active {
    opacity: 1;
  }
  .row-checkbox label.el-checkbox:hover::before {
    background-color: rgba(32,33,36,0.059);
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  .priority-icon-container {
    position: absolute;
    left: 4px;
    height: 100%;
    display: flex;
    top: -1px;
    align-items: center;
  }
  .priority-icon-container .high-priority {
    color: #ff9638;
  }
  .priority-icon-container .low-priority {
    color: #dbdcdc;
  }

  .no-orders-message {
    font-style: italic;
    color: #c0c6cf;
    margin: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/flight-orders/scrolled/FlightOrdersRecycleScroll.vue